/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Broadcast_HeadingInputs */

const th_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถ่ายทอดสดเกมนี้`)
};

const en_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcast this game`)
};

const ja_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この試合を配信する`)
};

const zh_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播这场比赛`)
};

const es_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retransmitir este partido`)
};

const pt_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmitir este jogo`)
};

const id_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siarkan pertandingan ini`)
};

const fr_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diffuser ce match`)
};

const tl_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isahimpapawid ang larong ito`)
};

const vi_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát trận này`)
};

const ko_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 경기 중계하기`)
};

const de_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Spiel übertragen`)
};

const ru_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транслировать этот матч`)
};

const tr_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu maçı yayınla`)
};

const it_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasmetti questa partita`)
};

const pl_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmituj ten mecz`)
};

const uk_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транслювати цей матч`)
};

const hi_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह मैच प्रसारित करें`)
};

const ar_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بثّ هذه المباراة`)
};

const ms_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siarkan perlawanan ini`)
};

const bn_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই খেলা সম্প্রচার করুন`)
};

const zh_tw2_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轉播這場比賽`)
};

const zh_hk2_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轉播這場比賽`)
};

const ur_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ میچ نشر کریں`)
};

const fa_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پخش این بازی`)
};

const sw_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rusha mchezo huu`)
};

const nl_video_broadcast_heading = /** @type {(inputs: Video_Broadcast_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze wedstrijd uitzenden`)
};

/**
* | output |
* | --- |
* | "Broadcast this game" |
*
* @param {Video_Broadcast_HeadingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_broadcast_heading = /** @type {((inputs?: Video_Broadcast_HeadingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Broadcast_HeadingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_broadcast_heading(inputs)
	if (locale === "ja") return ja_video_broadcast_heading(inputs)
	if (locale === "zh") return zh_video_broadcast_heading(inputs)
	if (locale === "es") return es_video_broadcast_heading(inputs)
	if (locale === "pt") return pt_video_broadcast_heading(inputs)
	if (locale === "id") return id_video_broadcast_heading(inputs)
	if (locale === "fr") return fr_video_broadcast_heading(inputs)
	if (locale === "tl") return tl_video_broadcast_heading(inputs)
	if (locale === "vi") return vi_video_broadcast_heading(inputs)
	if (locale === "ko") return ko_video_broadcast_heading(inputs)
	if (locale === "de") return de_video_broadcast_heading(inputs)
	if (locale === "ru") return ru_video_broadcast_heading(inputs)
	if (locale === "tr") return tr_video_broadcast_heading(inputs)
	if (locale === "it") return it_video_broadcast_heading(inputs)
	if (locale === "pl") return pl_video_broadcast_heading(inputs)
	if (locale === "uk") return uk_video_broadcast_heading(inputs)
	if (locale === "hi") return hi_video_broadcast_heading(inputs)
	if (locale === "ar") return ar_video_broadcast_heading(inputs)
	if (locale === "ms") return ms_video_broadcast_heading(inputs)
	if (locale === "bn") return bn_video_broadcast_heading(inputs)
	if (locale === "zh-TW") return zh_tw2_video_broadcast_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_video_broadcast_heading(inputs)
	if (locale === "ur") return ur_video_broadcast_heading(inputs)
	if (locale === "fa") return fa_video_broadcast_heading(inputs)
	if (locale === "sw") return sw_video_broadcast_heading(inputs)
	if (locale === "nl") return nl_video_broadcast_heading(inputs)
	return en_video_broadcast_heading(inputs)
});